<template>
  <v-autocomplete
      v-model="value"
      :items="items"
      item-text="name"
      item-value="uid"
      :label="label"
      :clearable="clearable"
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
    name: "r-boat-order-dropdown",
    props: {
        label: VueTypes.string.def("Select Order"),
        model: VueTypes.string.def(""),
        clearable: VueTypes.bool.def(false)
    },
    computed: {
        value: {
            get: function () {
                return this.model;
            },
            set: function (value) {
                this.$emit("update:model", value);
            }
        },
        items() {
            return RedactorUtils.getBoatOrders();
        }
    }
}

</script>
